<template>
    <div id="engineerManage">
        <div class="Engineer container">
            <span class="headerSpan" style="padding-bottom:10px;display:block">背包类型</span>
            <ul class="clearfix">
                <li v-for="(item,index) in EngineerLists" :key="index" class="EngineerListPart listPart"
                    @click="selectEngineer(item,index)">
                    <span v-bind:class="{active:activeIndex===index}"><i class="el-icon-check"></i></span>
                    <span class="exitBtn" v-if="basicsAuth.engineerGreadeEdit" @click.stop="exitEngineer(item)">编辑</span>
                    <!-- <i class="el-icon-error activeDelBtn" v-if="basicsAuth.delete_pack" @click.stop="deleteEngineerPack(item.id)"></i> -->
                    <em :class="{disabledColor:item.status == -1}">{{item.gradeName}}</em>
                </li>
                <li v-if="basicsAuth.engineerGreadeAdd" class="addContent" @click="newEngineer()"><i class="el-icon-plus"></i></li>
            </ul>
            <el-dialog :title="textMenu[dialogMenuStatus]" :visible.sync="dislogEngineer" :close-on-click-modal="false" width="600px"  @close="emptyDialog('EngineerForm')">
                <el-form ref="EngineerForm" :model="EngineerForm" label-width="120px" :label-position="labelPosition" :rules="EngineerFormRules">
                    <el-form-item label="等级名称：" prop="gradeName">
                        <el-input v-model.trim="EngineerForm.gradeName" placeholder="请输入等级名称(不超过20个字)" maxlength="20"></el-input>
                    </el-form-item>
                    <el-form-item label="启用状态：" prop="status">
                        <el-switch v-model="EngineerForm.status" :active-value="1" :inactive-value="-1" ></el-switch>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer" >
                    <el-button v-if="dialogMenuStatus!=='update' && basicsAuth.engineerGreadeEditFs " type="success" @click="addEventFormSubmitBtn('EngineerForm')">添加</el-button>
                    <el-button v-if="dialogMenuStatus =='update' && basicsAuth.engineerGreadeEditFs" type="success" @click="saveEventFormSubmitBtn('EngineerForm')">保存</el-button>
                    <el-button @click="emptyDialog('EngineerForm')">取 消</el-button>
                </span>
            </el-dialog>
        </div>
        <el-row class="container-part2">
            <el-col>
                <span class="headerSpan">品牌</span>
                <ul class="clearfix" style="margin-bottom: 15px;">
                    <li class="fl listPart" v-for="(item,index) in brandLists" :key="index" @click="selectBrand(item,index)"    v-bind:class="{active:activeBrandIndex===index}">{{item.brandName}}</li>
                </ul>
                <span class="headerSpan">品类</span>
                <ul class="clearfix" style="margin-bottom: 15px;">
                    <li @click="selectCategory(item,index)" class="fl listPart" v-for="(item,index) in categoryLists" :key="index" v-bind:class="{active:activeCategoryIndex===index}">{{item.categoryName}}</li>
                </ul>
                <span class="headerSpan">型号</span>
                <ul class="clearfix" style="margin-bottom: 15px;">
                    <li @click="selectModel(item,index)" v-bind:class="{active:activeModelIndex===index}" class="fl listPart" v-for="(item,index) in modelLists" :key="index">{{item.modelName}}</li>
                </ul>
            </el-col>
        </el-row>
        <el-row class="container containerTable">
            <p>选择擅长故障</p>
            <el-button size="small" type="primary" @click="exitMater()" style="margin: 10px 0;">
                {{exitHtml}}
            </el-button>
            <el-form ref="begoodForm" :model="begoodForm" label-width="80px">
                <el-checkbox-group v-model="checkList">
                    <el-checkbox :disabled="allowExit" v-for="(item,index) in faultLists" :key="index" :label="item.faultSubclassId" v-cloak> {{item.faultSubclassName}}</el-checkbox>
                </el-checkbox-group>
            </el-form>
        </el-row>
    </div>
</template>

<script>
    import {
        selectAllBrand,selectCategory,selectModel,insertWasteTreasure,engineerGreadeAdd,engineerGreadeEdit,faultSubclassByMode,engineerGreadeEditFs,engineerGreadeList,engineerPackDelete
    } from "../../api/api";
     import {getPermission} from '../../api/authRequest'
    export default {
        name: 'engineerManage',
        data() {
            const validateNumber = (rule, value, callback) => {
                if (/^99$|^(\d|[1-9]\d)$/.test(value) == false) {
                    callback(new Error("请输入一个大于0,小于99的整数"));
                }else {
                    callback();
                }
            }
            return {
                allowExit:true,       //可编辑
                checkList:[],         //选中擅长故障数组
                exitHtml:'编辑',      //编辑||保存
                defaultId: '',        //默认品牌Id
                activeIndex:0,        //背包选中状态
                labelPosition:'left',
                dislogEngineer:false,
                dialogMenuStatus: "", //update=>工程师等级修改 & 反之添加
                textMenu: {
                    update: "修改工程师",
                    create: "新增工程师"
                },
                EngineerLists:[],   //工程师数组
                EngineerForm:{
                    gradeName: '',
                    status: 1,
                },
                EngineerFormRules:{  //validateRoleName
                    gradeName: [{ required: true, message: "请输入基础包名称", trigger: "blur" }],
                },
                defaultBrandId:'',      //默认品牌ID
                defaultCategoryId:'',   //默认品类ID
                defaultModelId:'',      //默认模型ID
                defaultEngineerId:'',   //默认工程师等级ID
                brandLists:'',          //品牌数组
                categoryLists:'',       //品类数组
                modelLists:'',          //型号ID
                activeBrandIndex:0,     //品牌状态
                activeCategoryIndex:"", //品类状态
                activeModelIndex:"",    //型号状态
                begoodForm:{},          //故障表单
                faultLists:[],           //故障数组
                basicsAuth:{
                    engineerGreadeAdd:false,
                    engineerGreadeEdit:false,
                    engineerGreadeEditFs:false,
                    delete_pack:false
                }
            }
        },
        mounted () {
            this.getBrandLists();
            this.getEngineerList();

            this.basicsAuth.engineerGreadeAdd= getPermission('/api/engineerGrade/engineerGreadeAdd');
            this.basicsAuth.engineerGreadeEdit= getPermission('/api/engineerGrade/engineerGreadeEdit');
            this.basicsAuth.engineerGreadeEditFs= getPermission('/api/engineerGrade/engineerGreadeEditFs');
            this.basicsAuth.delete_pack= getPermission('/api/engineerPackType/delete_pack');
        },
        methods: {
            //删除工程师背包
            deleteEngineerPack(id){
                this.$confirm('确认删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    engineerPackDelete({id: id}).then(res => {
                        if (res.data.status==100) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        }
                    }).catch((error) =>{
                        this.$Message.error(error.message);
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            },
            //获取工程师列表
            getEngineerList(){
                engineerGreadeList().then(res => {
                    if (res.data.status==100) {
                        // console.log(res.data.results)
                        this.EngineerLists = res.data.results;
                        this.defaultEngineerId = this.EngineerLists[0].id;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //清空dialog
            emptyDialog(formName) {
                this.$refs[formName].resetFields();
                this.dislogEngineer = false
            },
            //选中工程师
            selectEngineer(item,index) {
                console.log(item)
                this.activeIndex = index
                this.EngineerForm = Object.assign({}, item);
                this.defaultEngineerId = this.EngineerForm.id;
                this.getByMode();
            },
            //新增工程师
            newEngineer() {
                this.EngineerForm = {
                    gradeName: '',
                    status: 1,
                };
                this.dislogEngineer = true;
                this.dialogMenuStatus = "create";
            },
            //确认新增
            addEventFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        let para={
                            gradeName:this.EngineerForm.gradeName,
                            status:this.EngineerForm.status,
                        }
                        engineerGreadeAdd(para).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogEngineer = false;
                                this.$refs[formname].resetFields();
                                /*刷新*/
                                this.getEngineerList();
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //编辑工程师
            exitEngineer(item) {
                this.dislogEngineer = true
                this.dialogMenuStatus = "update";
                this.EngineerForm = Object.assign({}, item);
            },
            //确认编辑
            saveEventFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        let para={
                            id:this.EngineerForm.id,
                            gradeName:this.EngineerForm.gradeName,
                            status:this.EngineerForm.status,
                        }
                        engineerGreadeEdit(para).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success" 
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogEngineer = false;
                                this.$refs[formname].resetFields();
                                /*刷新*/
                                this.getEngineerList();
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //查询品牌or获取品牌
            getBrandLists() {
                selectAllBrand().then(res => {
                    if (res.data.status==100) {
                        this.brandLists = res.data.results;
                        this.defaultBrandId = res.data.results[0].brandId;
                        this.getCategoryList(this.defaultBrandId);
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //选中品牌
            selectBrand(item,index) {
                this.activeBrandIndex = index;
                this.defaultBrandId = Object.assign({}, item).brandId;
                this.activeCategoryIndex = 0;
                this.activeModelIndex = 0;
                this.getCategoryList(this.defaultBrandId);
            },
            //获取品类
            getCategoryList(id){
                const brandId = id
                const brandData = {brandId:brandId}
                selectCategory(brandData).then((res) => {
                    if (res.data.status == 100) {
                        this.categoryLists = res.data.results;
                        this.defaultCategoryId = res.data.results[0].categoryId;
                        this.activeCategoryIndex = 0;
                        this.getModelList(this.defaultBrandId,this.defaultCategoryId);
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) => {
                    this.$Message.error(error.message);
                })
            },
            //选中品类
            selectCategory(item,index) {
                this.activeCategoryIndex = index;
                this.activeModelIndex = 0;
                this.defaultCategoryId = Object.assign({}, item).categoryId;
                this.getModelList(this.defaultBrandId,this.defaultCategoryId);
            },
            //获取型号
            getModelList(id1,id2){
                let para = {
                    brandId:id1,
                    categoryId:id2,
                }
                selectModel(para).then(res => {
                    if (res.data.status==100) {
                        this.modelLists = res.data.results;
                        this.defaultModelId = res.data.results[0].modelId;
                        this.activeModelIndex = 0;
                        this.getByMode();
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //选中型号
            selectModel(item,index) {
                this.activeModelIndex = index;
                this.defaultModelId = Object.assign({}, item).modelId;
                this.getByMode();
            },
            //根据条件带出所有故障，并标注已选择的
            getByMode(){
                let para={
                    gradeId:this.defaultEngineerId,
                    brandId:this.defaultBrandId,
                    categoryId:this.defaultCategoryId,
                    modelId:this.defaultModelId,
                };
                faultSubclassByMode(para).then(res => {
                    if (res.data.status==100) {
                        this.faultLists = res.data.results;
                        this.checkList = [];
                        this.faultLists.forEach((item,index)=>{
                            if(item.memo == '1'){
                                this.checkList.push(item.faultSubclassId)
                            }
                        })
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //编辑物料
            exitMater(){
                if (this.exitHtml == '编辑') {
                    this.exitHtml = '保存';
                    this.allowExit = false;
                }else{
                    this.exitHtml = '编辑';
                    this.allowExit = true;
                    this.addMaterSubmitBtn();
                }
            },
            addMaterSubmitBtn(){
                this.$refs['begoodForm'].validate((valid) => {
                    if (valid) {
                        let para={
                            gradeId:this.defaultEngineerId,
                            brandId:this.defaultBrandId,
                            categoryId:this.defaultCategoryId,
                            modelId:this.defaultModelId,
                            faultSubclassId:this.checkList
                        };
                        engineerGreadeEditFs(para).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: '保存成功',
                                    type: "success"
                                });
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            }
        },
        computed: {
        },
        watch: {
          
        }
    }
</script>

<style lang="scss" type="text/css" scoped>
    #engineerManage{
        font-size: 14px;
        .container{
            border-bottom: 1px solid #c6c6c6;
            padding: 20px 0;
            margin-bottom: 20px;
            h4{
                margin: 15px 0;
                font-weight: 500;
                font-size: 16px;
            }
            .listPart{
                width: 140px;
                float: left;
                border:1px solid #c6c6c6;
                margin:0 15px 10px 0;
                border-radius: 10px;
                height: 80px;
                line-height: 60px;
                text-align: center;
                position: relative;
                z-index: 0;
                cursor: pointer;
                & > span:first-child{
                    display:none;
                }
                span.active{
                    position: absolute;
                    top: -1px;
                    right:-1px;
                    display: block;
                    width: 30px;
                    height: 30px;
                    border-width: 16px;
                    border-style: solid;
                    border-color: #1abc9c #1abc9c #fff #fff;
                    border-top-right-radius:10px;
                    i{
                        position: absolute;
                        font-size: 14px;
                        color:#fff;
                        top: -9px;
                    }
                }
                em{
                    color: #000;
                    font-style: normal;
                    width: 95%;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    display: block;
                }
                em.disabledColor{
                    color:#dcdfe6;
                }
                span.exitBtn{
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    line-height: 20px;
                    left: 0;
                    border-top:1px solid #c6c6c6;
                    z-index:1;
                    display: block;
                }
                i.activeDelBtn{
                    display: none;
                    position: absolute;
                    top: 5px;
                    left: 5px;
                    color: #c41335;
                }
            }
            .listPart:hover i.activeDelBtn{
                display: block;
            }
            .addContent{
                border:1px dashed #c6c6c6;
                width: 50px;
                height: 50px;
                line-height: 50px;
                float: left;
                text-align: center;
                margin-top: 15px;
                cursor: pointer;
                i{
                    font-size: 20px;
                }
            }
        }
        .container-part2{
            border-bottom: 1px solid #c6c6c6;
            .headerSpan{
                margin-right: 20px;
                display: block;
            }
            .listPart{
                width:130px;
                border:1px solid #c6c6c6;
                margin:10px 15px 10px 0;
                border-radius: 5px;
                text-align: center;
                position: relative;
                z-index: 0;
                cursor: pointer;
                padding: 5px 10px;
            }
            li.active{
                background-color:#1abc9c;
                color:#fff;
                border-color: #1abc9c;
            }
            .el-checkbox.is-bordered+.el-checkbox.is-bordered {
                margin-left: 15px;
            }
        }
        .containerTable{
            border-color: transparent;
        }
        .toolbar{
            margin: 20px 0;
        }
        [v-cloak] {
            display: none;
        }
        .el-checkbox{
            width: 15%;
            float: left;
            text-align: left;
        }
        .is-checked{
            margin: 0px;
            text-align: left;
        }
        .el-checkbox+.el-checkbox {
            margin-left: 0px;
            text-align: left;
        }
    }
</style>



// WEBPACK FOOTER //
// engineerManage.vue?09ad2702